import './header.scss';
import './img/banner.png';
import './img/banner-handheld.jpg';
import './img/logitech_logo.svg';
import './img/asbis_logo.svg';
import './img/envelope.svg';


// lang_switcher();
// close_lang_switcher();
//
// function lang_switcher() {
//   $('.js-lang_btn').click(function (e) {
//     e.preventDefault();
//     e.stopPropagation();
//
//     $(this).toggleClass('act');
//     $('.js-lang_list').toggleClass('open');
//   });
// }
//
// function close_lang_switcher() {
//   $('html').click(function () {
//     if ($('.js-lang_btn').hasClass("act")) {
//       $('.js-lang_list').removeClass('open');
//       $('.js-lang_btn').removeClass('act');
//     }
//   });
// }



// WEBPACK FOOTER //
// ./resources/views/partials/index/header/header.js